import { DOC_LEVEL_DATA, DOC_LEVEL_DATA_TABLE15, LOADER_STATUS, VIEW_TABLE_DATA } from "./constants";

export const initialState = {
    loaderStatus: false,
    viewTableData: [],
    docLevelData:[],
    docLevelDataTable15:[],
    
  };
  const gstr1NewViewReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case VIEW_TABLE_DATA:
        return {
          ...state,
          viewTableData:action.viewTableData
        }
      case DOC_LEVEL_DATA:
        return{
          ...state,
          docLevelData: action.docLevelData
        }  
        case DOC_LEVEL_DATA_TABLE15:
        return{
          ...state,
          docLevelDataTable15: action.docLevelDataTable15
        }
      default:
        return state;
    }
  };
  export default gstr1NewViewReducer;  